import { TranslateService } from '@ngx-translate/core';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SliderComponent, SliderTickEventArgs, SliderTooltipEventArgs, SliderModule } from '@syncfusion/ej2-angular-inputs';
import { DateTime } from 'luxon';
import { IdProvider } from '../id-provider';

@Component({
    selector: 'app-duration-time-slider',
    templateUrl: './duration-time-slider.component.html',
    styleUrls: ['./duration-time-slider.component.scss'],
    imports: [SliderModule]
})
export class DurationTimeSliderComponent implements OnInit {

  @Input() public duration = 0;
  @Input() public step = 15;
  @Input() public id: string = `app-duration-time-slider-${IdProvider.getNextId()}`;
  @Output() public durationChange = new EventEmitter<number>();
  @ViewChild('slider') private slider: SliderComponent;
  @Input() public set startTime(value: Date) {
    if (this._startTime !== value) {
      this._startTime = value;
      this.slider?.refresh();
      // fix issue that duration setting gets lost on slider after refresh
      setTimeout(() => {
        this.slider?.writeValue(this.duration);
      }, 0);
    }
  }
  @Input() public set maxDuration(value: number) {
    this.limitsData = {enabled: true, minEnd: value};
    this.slider?.refresh();
  }

  public min = 0;
  public max: number = 24 * 60;
  public tooltipData = { placement: 'Before', isVisible: true };
  public ticksData = { placement: 'After', largeStep: 120 };
  public limitsData = { enabled: false, minEnd: 0 };

  public rangeType = 'MinRange';

  private _startTime: Date;

  constructor(private translateService: TranslateService) { }

  ngOnInit(): void {
  }

  public tooltipChangeHandler(args: SliderTooltipEventArgs): void {
    const durationInMinutes = args.value as number;
    const startTimeDateTime = this._startTime ? DateTime.fromJSDate(this._startTime) : DateTime.now().startOf('day');
    if (durationInMinutes >= 24 * 60) {
      args.text = this.translateService.instant('i18n.base.shared.duration-time-slider.duration') + ': 24:00' + ' / ' +
                      this.translateService.instant('i18n.base.shared.duration-time-slider.endTime') + ': ' + startTimeDateTime.toFormat('HH:mm');
    } else {
      args.text = this.translateService.instant('i18n.base.shared.duration-time-slider.duration') + ': ' +
                  DateTime.now().startOf('day').plus({minutes: durationInMinutes}).toFormat('HH:mm') + ' / ' +
                  this.translateService.instant('i18n.base.shared.duration-time-slider.endTime') + ': ' +
                  startTimeDateTime.plus({minutes: durationInMinutes}).toFormat('HH:mm');
    }
    this.durationChange.emit(durationInMinutes);
  }

  public renderingTicksHandler(args: SliderTickEventArgs): void {
    const startTimeDateTime = this._startTime ? DateTime.fromJSDate(this._startTime) : DateTime.now().startOf('day');
    args.text = startTimeDateTime.plus({minutes: args.value}).toFormat('HH:mm');
  }

}
